"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceMd, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "sx" && prop !== "disableMargins"
})(({ theme, disableMargins }) => ({
  alignItems: "flex-start",
  display: "flex",
  flexShrink: "0",
  gap: SpaceLg,
  height: "100%",
  padding: disableMargins ? `0` : `0px ${SpaceLg}`,
  [theme.breakpoints.down("md")]: {
    gap: SpaceMd,
    padding: `0px ${SpaceMd}`
  },
  "& > * ": {
    flex: "1 0 0"
  },
  ".MuiGrid-root > &": {
    padding: 0
  }
}));
export {
  StyledContainer
};
